export default function Services() {
  const services = [
    {
      icon: 'ri-water-flash-line',
      title: 'Osuszanie Pomieszczeń',
      description: 'Profesjonalne osuszanie po zalaniach z wykorzystaniem najnowocześniejszego sprzętu. Szybka reakcja i skuteczne działanie.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Wynajem Osuszaczy',
      description: 'Oferujemy wynajem profesjonalnych osuszaczy budowlanych. Dostępne różne modele dostosowane do Twoich potrzeb.'
    },
    {
      icon: 'ri-drop-line',
      title: 'Lokalizacja Wycieków',
      description: 'Precyzyjna lokalizacja ukrytych wycieków wodnych za pomocą specjalistycznej aparatury termowizyjnej i akustycznej.'
    },
    {
      icon: 'ri-hammer-line',
      title: 'Remonty Kompleksowe',
      description: 'Kompleksowe remonty mieszkań i domów. Od projektu po wykończenie - wszystko w jednym miejscu.'
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Wykończenia Wnętrz',
      description: 'Profesjonalne wykończenia wnętrz z dbałością o każdy detal. Tworzymy przestrzenie dopasowane do Twoich potrzeb.'
    },
    {
      icon: 'ri-alarm-warning-line',
      title: 'Interwencje Awaryjne',
      description: 'Dostępni 24 godziny na dobę, 7 dni w tygodniu. W sytuacjach awaryjnych reagujemy natychmiast.'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-blue-600 text-sm font-semibold uppercase tracking-wider mb-3">
            Nasze Specjalizacje
          </p>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
            Kompleksowe Rozwiązania<br />
            Dla Twojego Domu
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className={`${service.icon} text-5xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}